import { addStyles } from 'ethcss'
import { grid, IStyles, mediaCSS } from 'theme'
import { colors } from 'theme/colors'

const styles: IStyles = {
    wrapper: {
        paddingTop: 30,
    },
    title: {
        marginBottom: 20,
        fontSize: 20,
        padding: '0 30px',
    },
    statusList: {
        display: 'flex',
        padding: '0 30px 30px 30px',
        borderBottom: ` 1px solid ${colors.greyLight}`,
    },
    status: {
        marginRight: 20,
    },
    headerSplit: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 30px 10px 30px',
    },
    headerSplitLeft: {
        maxWidth: '30%',
    },
    p2pStatusRow: {
        marginBottom: 10,
        wordWrap: 'break-word',
    },
    headerSplitRight: {
        display: 'flex',
        alignItems: 'center',
    },
    updateButton: {
        textDecoration: 'underline',
        marginRight: 30,
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    switchWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 30,
    },
    switch: {
        marginLeft: 10,
    },
    intervalWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    intervalInput: {
        marginLeft: 10,
        width: 88,
    },
    displaysSection: {
        padding: '0 30px',
        height: 'calc(100vh - 230px)',
        overflow: 'auto',

        [mediaCSS.tab]: {
            height: 'calc(100vh - 300px)',
        },
    },
    displayHeader: {
        display: 'flex',
        border: '1px solid rgba(0, 0, 0, 0.14)',
        borderRadius: '5px 5px 0 0',
        backgroundColor: colors.greyLight,
        fontWeight: 700,
    },
    col: {
        padding: '10px 20px',
    },
    col_1: {
        width: '50%',
    },
    col_2: {
        borderLeft: '1px solid rgba(0, 0, 0, 0.14)',
        borderRight: '1px solid rgba(0, 0, 0, 0.14)',
        width: '25%',
        textAlign: 'center',
    },
    col_3: {
        width: '25%',
        textAlign: 'center',
    },
    col_noBorder: {
        borderColor: 'transparent !important',
    },
    col_inner: {
        paddingLeft: '48px !important',
    },
    col_borderBottom: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.14)',
    },
    col_borderLeft: {
        borderLeft: '1px solid rgba(0, 0, 0, 0.14)',
    },
    col_borderRight: {
        borderRight: '1px solid rgba(0, 0, 0, 0.14)',
    },
    fileHeader: {
        display: 'flex',
        border: '1px solid rgba(0, 0, 0, 0.14)',
        borderRadius: '5px 5px 0 0',
        backgroundColor: colors.greyLight,
    },
    displayInner: {
        display: 'flex',
        border: '1px solid rgba(0, 0, 0, 0)',
    },
    file: {
        display: 'flex',
        border: '1px solid rgba(0, 0, 0, 0)',
        marginTop: -2,
    },
    fileName: {
        display: 'flex',
        alignItems: 'center',
    },
    fileIcon: {
        marginRight: 10,
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    deviceName: {
        display: 'flex',
        alignItems: 'center',
    },
    deviceArrowIcon: {
        marginRight: 16,
    },
    downloadedWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    downloadedLabel: {
        marginRight: 10,
    },
    wordBreak: {
        wordBreak: 'break-word',
    },
}

addStyles(styles)
export default styles
